// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SwitchField-primaryButton-2Mzxc-","container":"SwitchField-container-1urbLG","label":"SwitchField-label-39eM5r"};